// @flow
import React, { Component, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";

import { AppbarMenuItem } from "imagus-components";
import UserAuth from "../containers/UserAuth";

type AuthedAppbarMenuItemPropsType = {
  location: *,
  auth?: Array<string>,
  to?: string
};

class AuthedAppbarMenuItem extends Component<AuthedAppbarMenuItemPropsType, *> {
  render(): React$Element<*> {
    const { auth, to, ...other } = this.props;
    const pathname = this.props.location.pathname;

    if (auth) {
      if (to) {
        return (
          <UserAuth oneOfPrincipalList={auth}>
            <Link to={to}>
              <AppbarMenuItem selected={pathname == to} {...other} />
            </Link>
          </UserAuth>
        );
      } else {
        return (
          <UserAuth oneOfPrincipalList={auth}>
            <AppbarMenuItem selected={pathname == to} {...other} />
          </UserAuth>
        );
      }
    } else {
      if (to) {
        return (
          <Link to={to}>
            <AppbarMenuItem selected={pathname == to} {...other} />
          </Link>
        );
      } else {
        return <AppbarMenuItem selected={pathname == to} {...other} />;
      }
    }
  }
}

export default withRouter(AuthedAppbarMenuItem);
